// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-item-list-wrapper .cart-item-shipping-divider {
  margin-top: var(--spacin-extra-small);
  margin-bottom: var(--spacing-small);
}
.cart-item-list-wrapper .cart-item-shipping-divider.divider {
  height: 1px;
  background-color: #EAEAEA;
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.cart-item-list-wrapper .cart-item-shipping .cart-vendor-name {
  font-size: var(--font-paragraph);
  font-weight: 400;
}
.cart-item-list-wrapper .cart-item-shipping .cart-vendor-name span {
  font-weight: 600;
}
.cart-item-list-wrapper .cart-item-shipping .vendor-shipping-value {
  font-size: var(--font-paragraph);
  font-weight: 600;
}
.cart-item-list-wrapper .cart-item-shipping .vendor-shipping-value span {
  font-weight: 400;
}
.cart-item-list-wrapper .cart-item-shipping .vendor-shipping-value span.highlight {
  font-weight: 500;
  color: var(--color-highlight);
}
.cart-item-list-wrapper .cart-item-wrapper {
  margin: var(--spacing-small) 0;
}
.cart-item-list-wrapper .cart-item-wrapper .divider {
  height: 1px;
  background-color: #EAEAEA;
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.cart-item-list-wrapper .cart-item-wrapper .action-buttons-wrapper {
  display: flex;
  gap: var(--spacing-small);
}
.cart-item-list-wrapper .cart-item-wrapper .action-buttons-wrapper .cart-item-action-buttons {
  display: flex;
  gap: var(--spacing-small);
}
.cart-item-list-wrapper .cart-item-wrapper .action-buttons-wrapper .cart-item-action-buttons .delete-action .vert-paragraph {
  margin-left: 0;
}
.cart-item-list-wrapper .unavailable-container {
  width: auto;
  padding: 6px 11px ;
  border: 2px solid var(--color-warning);
  border-radius: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.cart-item-list-wrapper .unavailable-container .unavailable-content {
  color: var(--color-warning);
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-item-list-wrapper .unavailable-container .unavailable-content .icon-unavailable {
  color: var(--color-warning);
  font-size: 14.5px;
  margin-left: -3px;
}
.cart-item-list-wrapper .unavailable-container .unavailable-content span {
  margin-left: 6px;
  font-size: 13px;
  font-weight: 400;
  font-family: Poppins;
  color: var(--color-neutral-dark-darker);
}
.cart-item-list-wrapper .cart-item-coupon-alert {
  margin: var(--spacing-small) 0;
  max-width: 45%;
  padding: 1px 10px;
}
@media (max-width: 768px) {
  .cart-item-list-wrapper .cart-item-coupon-alert {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartItemListStyles.less"],"names":[],"mappings":"AAAA;EAEQ,qCAAA;EACA,mCAAA;AAAR;AAEQ;EACI,WAAA;EACA,yBAAA;EACA,kCAAA;EACA,qCAAA;AAAZ;AATA;EAeY,gCAAA;EACA,gBAAA;AAHZ;AAbA;EAmBgB,gBAAA;AAHhB;AAhBA;EAwBY,gCAAA;EACA,gBAAA;AALZ;AApBA;EA4BgB,gBAAA;AALhB;AAOgB;EACI,gBAAA;EACA,6BAAA;AALpB;AA3BA;EAuCQ,8BAAA;AATR;AA9BA;EAyCY,WAAA;EACA,yBAAA;EACA,kCAAA;EACA,qCAAA;AARZ;AApCA;EAgDY,aAAA;EACA,yBAAA;AATZ;AAxCA;EAoDgB,aAAA;EACA,yBAAA;AAThB;AA5CA;EAyDwB,cAAA;AAVxB;AA/CA;EAkEQ,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAhBR;AAxDA;EA2EY,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBZ;AA9DA;EAiFgB,2BAAA;EACA,iBAAA;EACA,iBAAA;AAhBhB;AAnEA;EAuFgB,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,uCAAA;AAjBhB;AA1EA;EAiGQ,8BAAA;EACA,cAAA;EACA,iBAAA;AApBR;AAuBI;EAAA;IAEQ,eAAA;EArBV;AACF","sourcesContent":[".cart-item-list-wrapper {\n    .cart-item-shipping-divider {\n        margin-top: var(--spacin-extra-small);\n        margin-bottom: var(--spacing-small);\n\n        &.divider {\n            height: 1px;\n            background-color: #EAEAEA;\n            margin-top: var(--spacing-regular);\n            margin-bottom: var(--spacing-regular);\n        }\n    }\n    .cart-item-shipping {\n       \n        .cart-vendor-name {\n            font-size: var(--font-paragraph);\n            font-weight: 400;\n\n            span {\n                font-weight: 600;\n            }\n        }\n\n        .vendor-shipping-value {\n            font-size: var(--font-paragraph);\n            font-weight: 600;\n\n            span {\n                font-weight: 400;\n\n                &.highlight {\n                    font-weight: 500;\n                    color: var(--color-highlight);\n                }\n            }\n\n        }\n    }\n    .cart-item-wrapper {\n        margin: var(--spacing-small) 0;\n        .divider {\n            height: 1px;\n            background-color: #EAEAEA;\n            margin-top: var(--spacing-regular);\n            margin-bottom: var(--spacing-regular);\n        }\n\n        .action-buttons-wrapper {\n            display: flex;\n            gap: var(--spacing-small);\n\n            .cart-item-action-buttons {\n                display: flex;\n                gap: var(--spacing-small);\n\n                .delete-action {\n                    .vert-paragraph {\n                        margin-left: 0;\n                    }\n                }\n            }\n        }\n    }\n\n\n    .unavailable-container{\n        width: auto;\n        padding: 6px 11px ;\n        border: 2px solid var(--color-warning);\n        border-radius: 6px;\n        text-align: center;\n        display: flex;\n        justify-content: center;\n\n        .unavailable-content{\n            color: var(--color-warning);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .icon-unavailable{\n                color: var(--color-warning);\n                font-size: 14.5px;\n                margin-left: -3px;\n            }\n\n            span{\n                margin-left: 6px;\n                font-size: 13px;\n                font-weight: 400;\n                font-family: Poppins;\n                color: var(--color-neutral-dark-darker);\n            }\n        }\n    }\n\n    .cart-item-coupon-alert{\n        margin: var(--spacing-small) 0;\n        max-width: 45%;\n        padding: 1px 10px;\n    }\n\n    @media (max-width: 768px) {\n        .cart-item-coupon-alert{\n            max-width: 100%;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
